'use strict';

import Vue from 'vue';
import prop from 'ramda/src/prop';

const count = prop('count');

export const state = Vue.observable({
	count: 0,
});

export async function update() {
	return import('axios').then(({ default: axios }) => {
		const request = axios.get('/api/basket/count/');

		request.then(({ data }) => state.count = count(data));

		return request;
	});
}

document.addEventListener('DOMContentLoaded', update);
